import { Person, Settings, VpnKeyOutlined } from '@mui/icons-material';
import { Chip, ListItemButton, ListItemIcon, ListItemText, SvgIcon } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouterLink } from 'src/components/router-link';
import useCurrentUser from 'src/hooks/use-current-user';
import SignaturePinDialog from 'src/components/signature/signature-pin-dialog';
import { useSignatureValidation } from 'src/hooks/use-signature-validation';
import { useStopwatch } from 'src/layouts/check-in-checkout/StopwatchContext';
import { paths } from 'src/paths';
import { Permissions, useScopeChecker } from 'src/rbac';
import { postTimeCheckOutAction } from 'src/redux/actions/therapist-dashboard-action';
import { TOP_NAV_TEST_IDS } from '../test-ids';
import { logoutUser } from 'src/routes/AuthContext';

interface AccountPopoverProps {
  anchorEl: null | Element;
  onClose?: () => void;
  open?: boolean;
}

export const AccountPopover: FC<AccountPopoverProps> = (props) => {
  const { anchorEl, onClose, open, ...other } = props;
  const dispatch = useDispatch();
  const { globalLocationType, setIsRunning } = useStopwatch();
  const user = useSelector((state: any) => state.getTherapistProfileReducer?.response?.data);
  const has = useScopeChecker();
  const [providerId] = useCurrentUser(['providerId']);

  const getTimeCheckIn = useSelector((state: any) => state.checkInReducer);
  const getResponseOfCheckout = useSelector((state: any) => state.checkoutReducer);
  const { enabled: signatureValidationEnabled } = useSignatureValidation();
  const [openSignaturePin, setOpenSignaturePin] = useState(false);

  const handleLogout = (e: any) => {
    e.preventDefault();
    setIsRunning(false);
    localStorage.setItem('isCheckIn', 'false');
    localStorage.removeItem('isCheckIn');
    localStorage.removeItem('lastRunningTime');
    // if (
    //   getResponseOfCheckout?.response !== null &&
    //   getResponseOfCheckout?.response?.data?.requestedTimerStatus === 'CLOCK_IN'
    // ) {
    //   const currentTime = new Date().toISOString();
    //   dispatch(
    //     postTimeCheckOutAction({
    //       providerId,
    //       date: currentTime,
    //       timer: 'CLOCK_OUT',
    //       clockId: getTimeCheckIn?.withPersistResponse?.data?.uuid,
    //       isLogout: true,
    //       idleTimeExpired: false,
    //       clockInBody: {
    //         locationType: globalLocationType,
    //         payByMilage: null,
    //       },
    //     })
    //   );
    //   return;
    // } else {
    logoutUser();
    // }
  };

  return (
    <>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        disableScrollLock
        onClose={onClose}
        open={!!open}
        PaperProps={{ sx: { width: 200 }, 'data-testid': TOP_NAV_TEST_IDS.userMenuPopover } as any}
        {...other}
      >
        {has(Permissions.PHYSICIAN_DASHBOARD) ? (
          <>
            <Box sx={{ p: 2 }}>
              <Typography variant="body1">{`${user?.firstName
                ?.toUpperCase()
                .charAt(0)}${user?.firstName?.slice(1)}`}</Typography>
              <Typography
                color="text.secondary"
                variant="body2"
              >
                {user?.email || ''}
              </Typography>
            </Box>
          </>
        ) : (
          user?.firstName &&
          user?.lastName && (
            <Box sx={{ p: 2 }}>
              <Typography variant="body1">{`${user?.lastName
                ?.toUpperCase()
                .charAt(0)}${user?.lastName?.slice(1)} ${user?.firstName
                ?.toUpperCase()
                .charAt(0)}${user?.firstName?.slice(1)}`}</Typography>
              <Typography
                color="text.secondary"
                variant="body2"
              >
                {user?.email || ''}
              </Typography>
            </Box>
          )
        )}

        <Divider />
        <Box sx={{ p: 1 }}>
          {/* <ListItemButton
          component={RouterLink}
          href="#"
          onClick={onClose}
          sx={{
            borderRadius: 1,
            px: 1,
            py: 0.5,
          }}
        >
          <ListItemIcon>
            <SvgIcon fontSize="small">
              <Person />
            </SvgIcon>
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body1">Profile</Typography>} />
        </ListItemButton> */}
          {signatureValidationEnabled && (
            <ListItemButton
              onClick={() => {
                setOpenSignaturePin(true);
                onClose?.();
              }}
              data-testid={TOP_NAV_TEST_IDS.signaturePin}
              sx={{
                borderRadius: 1,
                px: 1,
                py: 0.5,
              }}
            >
              <ListItemIcon>
                <SvgIcon fontSize="small">
                  <VpnKeyOutlined />
                </SvgIcon>
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body1">Signature &amp; PIN</Typography>}
              />
              <Chip
                size="small"
                color="primary"
                label="NEW"
                sx={{ height: 18, fontSize: 10 }}
              />
            </ListItemButton>
          )}
          <ListItemButton
            component={RouterLink}
            href={paths.postAuthResetPassword}
            data-testid={TOP_NAV_TEST_IDS.resetPassword}
            sx={{
              borderRadius: 1,
              px: 1,
              py: 0.5,
            }}
          >
            <ListItemIcon>
              <SvgIcon fontSize="small">
                <Settings />
              </SvgIcon>
            </ListItemIcon>
            <ListItemText primary={<Typography variant="body1">Reset Password</Typography>} />
          </ListItemButton>
        </Box>
        <Divider sx={{ my: '0 !important' }} />
        <Box
          sx={{
            display: 'flex',
            p: 1,
            justifyContent: 'center',
          }}
        >
          <Button
            // color="inherit"
            onClick={(e) => handleLogout(e)}
            data-testid={TOP_NAV_TEST_IDS.signOut}
            fullWidth
            size="small"
            type="button"
            variant="outlined"
          >
            Logout
          </Button>
        </Box>
      </Popover>
      <SignaturePinDialog
        open={openSignaturePin}
        onClose={() => setOpenSignaturePin(false)}
      />
    </>
  );
};
